import "./page-title.css";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { cn } from "../../lib/utils";
import { PageNavigation } from "./PageNavigation";

export function PageBackLink({ to, label = "Back", className }) {
  return (
    <PageNavigation>
      <Link
        to={to}
        title={typeof label === "string" ? label : undefined}
        className={cn(
          "page-back-link",
          className
        )}
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        <span>{label}</span>
      </Link>
    </PageNavigation>
  );
}